import { useQuery } from '@tanstack/react-query';
import { trustRequestTransactionApi } from '../api';
import type { TrustRequestTransactionQueryParams } from '../types/trustRequestTransactionTypes';

// Query keys
export const trustRequestTransactionKeys = {
  all: ['trust-request-transactions'] as const,
  lists: () => [...trustRequestTransactionKeys.all, 'list'] as const,
  list: (params: TrustRequestTransactionQueryParams) => [...trustRequestTransactionKeys.lists(), { params }] as const,
};

/**
 * Query hook for fetching trust request transactions with filtering and pagination
 */
export function useTrustRequestTransactions(params: TrustRequestTransactionQueryParams = {}) {
  return useQuery({
    queryKey: trustRequestTransactionKeys.list(params),
    queryFn: () => trustRequestTransactionApi.getTrustRequestTransactions(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
